import { createContext } from "react";

const MultiLevelSelectContext = createContext<any>({});

export default MultiLevelSelectContext;